import styled from "styled-components";
import SecondaryButton from "./SecondaryButton";

export default styled(SecondaryButton)`
  font-size: 1.375em;
  height: 3.243em;
  border-radius: 0.227em;
`;
